<template>
  <div class="fill-height of-y" style="overflow-x: hidden">
    <transition enter-active-class="scale-in-center" leave-active-class="scale-out-center" mode="out-in">
      <div class="c-d-flex c-align-center c-justify-center fill-height" v-if="loading" key="loading">
        <v-progress-circular
            :size="40"
            :width="3"
            color="secondary"
            indeterminate
        ></v-progress-circular>
      </div>
      <div v-else key="loaded" class="fill-height of-y c-d-flex c-flex-column" style="overflow-x: hidden">
        <div class="c-flex-grow-0 primary">
          <v-tabs
              dark
              color="primary"
              v-model="activeTab"
              slider-color="secondary"
          >
            <v-tab
                v-for="tab in tabs"
                :key="tab.id"
                ripple
            >
              {{ tab.title }}
            </v-tab>
          </v-tabs>
        </div>
        
        <transition enter-active-class="scale-in-center" leave-active-class="scale-out-center" mode="out-in">
          <v-layout class="c-flex-grow-1 of-y" v-if="selectedTab === 'models'" key="models" style="overflow-x: hidden">
            <v-flex xs4 class="of-y" style="position: relative">
              <div style="position: sticky; top: 0; left: 0; width: 100%; z-index: 1" class="card-back pa-1">
                <div class="c-d-flex c-align-center">
                  <v-text-field
                      solo
                      v-model="modelSearchStr"
                      hide-details
                      single-line
                      prepend-inner-icon="search"
                      placeholder="Search Models"
                  >
                    <template #append>
                      <v-tooltip top>
                        <template #activator="{on}">
                          <v-btn
                              v-on="on"
                              small
                              icon
                              @click="showDisabledModels = !showDisabledModels"
                              color="grey"
                              flat
                          >
                            <v-icon>{{ showDisabledModels ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                          </v-btn>
                        </template>
                        <template slot="default">
                          {{ showDisabledModels ? 'Hide disabled' : 'Show disabled' }}
                        </template>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                  <v-btn
                      class="ml-2"
                      color="secondary"
                      icon
                      @click="newModel"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </div>
              
              </div>
              
              <v-list>
                <v-list-tile
                    :value="selectedModel === model"
                    v-for="model in filteredModels"
                    :key="model.id"
                    avatar
                    @click="selectedModel = model"
                    active-class="selected-item"
                >
                  <!--                    <v-list-tile-avatar>-->
                  <!--                      <img :src="item.avatar">-->
                  <!--                    </v-list-tile-avatar>-->
                  
                  <v-list-tile-content>
                    <v-list-tile-title v-html="model.name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="model.ecosystem"></v-list-tile-sub-title>
                  </v-list-tile-content>
                  
                  <v-list-tile-action v-if="!model.isActive">
                    [Disabled]
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-flex>
            <transition enter-active-class="slide-in-right" leave-active-class="slide-out-right" mode="out-in">
              <v-flex :key="selectedModel.id" xs8 class="of-y pa-2" style="position: relative" v-if="selectedModel">
                <v-card style="max-height: 100%" class="of-y">
                  
                  <!--                <div class="c-d-flex c-flex-column">-->
                  <!--                  <div class="">-->
                  <!--                    -->
                  <!--                  </div>-->
                  <!--                </div>-->
                  
                  <div class="px-3 py-2 primary text-h6 white--text"
                       style="position: sticky; top: 0; left: 0; width: 100%; z-index: 1">
                    {{ selectedModel.id ? selectedModel.name : 'New Model' }}
                  </div>
                  
                  <v-card-text class="c-d-flex">
                    <div class="c-flex-grow-1 c-flex-equal">
                      
                      <div class="caption text--disabled pb-2">
                        Info
                      </div>
                      
                      <v-form class="px-2" ref="modelInfoForm">
                        
                        <v-text-field
                            label="Name"
                            v-model="modModel.name"
                            :rules="[validationRules.required]"
                        />
                        
                        <v-text-field
                            label="Model Id"
                            v-model="modModel.modelId"
                            :rules="[validationRules.required]"
                        />
                        
                        <v-autocomplete
                            label="Ecosystem"
                            v-model="modModel.ecosystem"
                            :items="['Anthropic', 'OpenAI', 'Google', 'Local']"
                            :rules="[validationRules.required]"
                        />
                        
                        <v-checkbox
                            label="Tools Enabled"
                            v-model="modModel.isToolsEnabled"
                            hide-details
                        />
                        
                        <v-checkbox
                            label="Enabled"
                            v-model="modModel.isActive"
                            hide-details
                        />
                        
                      </v-form>
                    </div>
                    <div class="c-flex-grow-1 c-flex-equal">
                      <div class="caption text--disabled">
                        Pricing
                      </div>
                      
                      <div class="px-2 pt-2">
                        <v-data-table
                            :headers="headers"
                            :items="sortedPricing"
                            class="elevation-1"
                        >
                          <template #no-data>
                            <v-alert :value="true" color="error" icon="warning">
                              AT LEAST ONE PRICE NEEDS TO BE DEFINED
                            </v-alert>
                          </template>
                          <template v-slot:items="props">
                            <td>{{ format(props.item.startDate, 'YYYY-MM-DD') }}</td>
                            <td class="text-xs-center">${{ props.item.mTokenInput.toFixed(3) }}</td>
                            <td class="text-xs-center">${{ props.item.mTokenOutput.toFixed(3) }}</td>
                            <td class="text-xs-center">x {{ props.item.costMultiplier.toFixed(2) }}</td>
                            <td class="text-xs-right" style="width: 30px">
                              <v-menu offset-x :close-on-content-click="false" ref="pricingMenu" lazy>
                                <template v-slot:activator="{ on }">
                                  <v-btn small flat icon v-on="on">
                                    <v-icon>more_vert</v-icon>
                                  </v-btn>
                                </template>
                                <ai-admin-setup-pricing-card
                                    :value="props.item"
                                    @input="updatePrice(props.item, $event)"
                                    @remove="removePrice"
                                    style="width: 500px"
                                />
                              </v-menu>
                            </td>
                          </template>
                          
                          <template v-slot:footer>
                            <td :colspan="headers.length">
                              <v-menu offset-x :close-on-content-click="false" ref="pricingMenu" lazy>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                      small
                                      flat
                                      color="secondary"
                                      block
                                      v-on="on"
                                  >
                                    Add Pricing
                                  </v-btn>
                                </template>
                                <ai-admin-setup-pricing-card
                                    :show-remove="false"
                                    :value="{
                                    fk_model: selectedModel.id,
                                    startDate: new Date(),
                                    mTokenOutput: 0,
                                    mTokenInput: 0,
                                  }"
                                    @input="modModelPricing.push($event)"
                                />
                              </v-menu>
                            
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    
                    </div>
                  </v-card-text>
                  
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        flat
                        color="disabled"
                        @click="modModel = JSON.parse(JSON.stringify(selectedModel))"
                        :disabled="savingValues"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        color="secondary"
                        @click="upsertModel"
                        :disabled="savingValues"
                        :loading="savingValues"
                    >
                      Save Changes
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </transition>
          
          </v-layout>
          <div class="c-flex-grow-1 of-y pa-3 fill-height of-y" v-else-if="selectedTab === 'exchange'" key="exchange">
            <div class="fill-height of-y" style="position:relative;">
              <div>
                <div class="c-d-flex c-align-center">
                  <div class="c-flex-grow-1 headline">USD To Zar Exchange Rates</div>
                  <v-btn flat small color="disabled" @click="resetExchange" :disabled="savingValues">Cancel</v-btn>
                  
                  
                  <v-menu offset-x :close-on-content-click="false" lazy>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          small
                          color="secondary"
                          v-on="on"
                          :disabled="savingValues"
                      >
                        Add
                      </v-btn>
                    </template>
                    
                    <template #default>
                      <ai-admin-setup-exchange-card
                          style="width: 500px"
                          :show-remove="false"
                          :value="{startDate: new Date(), usdToZar: 0}"
                          @input="modExchangeRates.push($event)"
                      />
                    </template>
                  </v-menu>
                  
                  <v-btn small color="secondary" :disabled="savingValues" :loading="savingValues" @click="upsertExchange">Save Changes</v-btn>
                </div>
              </div>
              
              <v-data-table
                  style="width: 100%"
                  :headers="exchangeHeaders"
                  :items="sortedExchangeRates"
                  class="elevation-1 my-2"
                  :rows-per-page-items="[{'text':'ALL','value': -1},5,10,25]"
              >
                <!--              <template #no-data>-->
                <!--                <v-alert :value="true" color="error" icon="warning">-->
                <!--                  AT LEAST ONE PRICE NEEDS TO BE DEFINED-->
                <!--                </v-alert>-->
                <!--              </template>-->
                <template v-slot:items="props">
                  <td><v-icon left :color="sortedExchangeRatesIndex[props.item.startDate] === 'trending_down' ? 'success' : 'error'">{{sortedExchangeRatesIndex[props.item.startDate]}}</v-icon> {{ format(props.item.startDate, 'YYYY-MM-DD') }}</td>
                  <td class="text-xs-center">R {{ props.item.usdToZar.toFixed(2) }}</td>
                  <td class="text-xs-right" style="width: 30px">
                    <v-menu offset-x :close-on-content-click="false"  lazy>
                      <template v-slot:activator="{ on }">
                        <v-btn small flat icon v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <ai-admin-setup-exchange-card
                          :value="props.item"
                          @input="updateExchange(props.item, $event)"
                          @remove="removeExchange"
                          style="width: 500px"
                      />
                    </v-menu>
                  </td>
                </template>
              </v-data-table>
            </div>
            
            
            
            
          
          
          </div>
          <div class="c-flex-grow-1 of-y pa-3 fill-height of-y" v-else-if="selectedTab === 'apiKeys'" key="apiKeys">
            <div class="fill-height of-y" style="position:relative;">
              <div>
                <div class="c-d-flex c-align-center">
                  <div class="c-flex-grow-1 headline">API Keys</div>
                  <v-btn flat small color="disabled" @click="resetApiKeys" :disabled="savingValues">Cancel</v-btn>
                  
                  <v-btn small color="secondary" :disabled="savingValues" :loading="savingValues" @click="upsertKeys">Save Changes</v-btn>
                </div>
              </div>
              
              <v-data-table
                  style="width: 100%"
                  :headers="apiKeyHeaders"
                  :items="sortedApiKeys"
                  class="elevation-1 my-2"
                  :rows-per-page-items="[{'text':'ALL','value': -1},5,10,25]"
              >
                <!--              <template #no-data>-->
                <!--                <v-alert :value="true" color="error" icon="warning">-->
                <!--                  AT LEAST ONE PRICE NEEDS TO BE DEFINED-->
                <!--                </v-alert>-->
                <!--              </template>-->
                <template v-slot:items="props">
                  
                  <td>{{ props.item.ecosystem }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>
                    <div class="c-d-flex c-align-center">
                      <span v-if="!showApiKeyInTable[props.item.fkModel]">
                        {{ props.item.key ? '••••••••••••••••' : '' }}
                      </span>
                      <span v-else>
                        {{ props.item.key || '' }}
                      </span>
                      <v-btn
                          v-if="props.item.key"
                          small
                          flat
                          icon
                          @click="toggleApiKeyVisibility(props.item.fkModel)"
                          class="ml-2"
                      >
                        <v-icon small>
                          {{ showApiKeyInTable[props.item.fkModel] ? 'visibility_off' : 'visibility' }}
                        </v-icon>
                      </v-btn>
                    </div>
                  </td>
                  
                  
                  <td class="text-xs-right" style="width: 30px">
                    <v-btn
                        small
                        flat
                        icon
                        @click="openApiKeyDialog(props.item)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- API Key Edit Dialog -->
              <v-dialog v-model="apiKeyDialog" max-width="500" persistent>
                <v-card>
                  <v-card-title class="primary white--text">
                    Edit API Key
                  </v-card-title>
                  <v-card-text class="pt-3">
                    <v-form ref="apiKeyForm">
                      <v-text-field
                          label="Ecosystem"
                          v-model="editingApiKey.ecosystem"
                          disabled
                          filled
                      />
                      <v-text-field
                          label="Model Name"
                          v-model="editingApiKey.name"
                          disabled
                          filled
                      />
                      <v-text-field
                          label="API Key"
                          v-model="editingApiKey.key"
                          :type="showApiKey ? 'text' : 'password'"
                          :append-icon="showApiKey ? 'visibility' : 'visibility_off'"
                          @click:append="showApiKey = !showApiKey"
                          placeholder="Enter API key"
                          hint="Enter the API key for this model"
                          persistent-hint
                      />
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        flat
                        color="disabled"
                        @click="closeApiKeyDialog"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        color="secondary"
                        @click="saveApiKey"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import {validationRules} from "@/codeFunctions";
import format from "date-fns/format";
import AiAdminSetupPricingCard from "@/Ai/Admin/aiAdminSetupPricingCard.vue";
import AiAdminSetupExchangeCard from "@/Ai/Admin/aiAdminSetupExchangeCard.vue";

export default {
  components: {AiAdminSetupExchangeCard, AiAdminSetupPricingCard},
  
  props: {
    propName: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {title: 'Models', id: 'models'},
        {title: 'Exchange Rates', id: 'exchange'},
        {title: 'API Keys', id: 'apiKeys'},
      ],
      loading: true,
      models: [],
      pricing: [],
      exchangeRates: [],
      modelSearchStr: null,
      showDisabledModels: false,
      selectedModel: null,
      modModel: null,
      modModelPricing: null,
      savingValues: false,
      // fk_model,
      // startDate,
      // mTokenOutput,
      // mTokenInput,
      headers: [
        {
          text: 'Start Date',
          align: 'left',
          value: 'startDate'
        },
        {text: 'Input Per M Tok', value: 'mTokenInput', align: 'center'},
        {text: 'Output Per M Tok', value: 'mTokenOutput', align: 'center'},
        {text: 'Cost Multiplier', value: 'costMultiplier', align: 'center'},
        {text: '', value: 'actions', align: 'right', sortable: false, width: 30},
      ],
      exchangeHeaders: [
        {
          text: 'Start Date',
          align: 'left',
          value: 'startDate'
        },
        {text: 'USD to Zar', value: 'usdToZar', align: 'center'},
        {text: '', value: 'actions', align: 'right', sortable: false, width: 30},
      ],
      apiKeyHeaders: [
        {text: 'ecosystem', align: 'left', value: 'ecosystem'},
        {text: 'name', align: 'left', value: 'name'},
        {text: 'key', align: 'left', value: 'key'},
        {text: '', value: 'actions', align: 'right', sortable: false, width: 30},
      ],
      modExchangeRates: [],
      apiKeys: [],
      modApiKeys: [],
      // API Key Dialog properties
      apiKeyDialog: false,
      editingApiKey: {
        ecosystem: '',
        name: '',
        key: '',
        fkModel: null,
      },
      editingApiKeyIndex: null,
      showApiKey: false,
      showApiKeyInTable: {}, // Track visibility state for each API key in the table
    }
  },
  mounted() {
    this.startup();
  },
  watch: {
    exchangeRates: {
      immediate: true,
      handler(val) {
        this.modExchangeRates = val.map(v => ({
          ...v,
          startDate: v.startDate ? new Date(v.startDate) : null,
        }))
      }
    },
    apiKeys: {
      immediate: true,
      handler(val) {
        this.modApiKeys = this.models.map(v => ({
          ecosystem: v.ecosystem,
          name: v.name,
          fkModel: v.id,
          key: this.apiKeys.find(k => k.fkModel === v.id)?.key || null,
        }))
      }
    },
    selectedModel(val) {
      this.modModel = JSON.parse(JSON.stringify(val))
      this.modModelPricing = this.pricing
          .filter(v => v.fk_model === this.selectedModel?.id)
          .map(v => ({
            ...v,
            startDate: v.startDate ? new Date(v.startDate) : null,
          }))
    }
  },
  methods: {
    format,
    resetExchange() {
      this.modExchangeRates = this.exchangeRates.map(v => ({
        ...v,
        startDate: v.startDate ? new Date(v.startDate) : null,
      }))
    },
    resetApiKeys() {
      this.modApiKeys = this.models.map(v => ({
        ecosystem: v.ecosystem,
        name: v.name,
        fkModel: v.id,
        key: this.apiKeys.find(k => k.fkModel === v.id)?.key || null,
      }))
    },
    openApiKeyDialog(item) {
      // Find the index of the item in modApiKeys
      this.editingApiKeyIndex = this.modApiKeys.findIndex(k =>
        k.fkModel === item.fkModel &&
        k.ecosystem === item.ecosystem &&
        k.name === item.name
      )
      // Clone the item for editing
      this.editingApiKey = {
        ...item,
        key: item.key || ''
      }
      this.showApiKey = false
      this.apiKeyDialog = true
    },
    closeApiKeyDialog() {
      this.apiKeyDialog = false
      this.editingApiKey = {
        ecosystem: '',
        name: '',
        key: '',
        fkModel: null,
      }
      this.editingApiKeyIndex = null
      this.showApiKey = false
    },
    saveApiKey() {
      if (this.editingApiKeyIndex !== null && this.editingApiKeyIndex >= 0) {
        // Update the key in modApiKeys
        this.modApiKeys[this.editingApiKeyIndex].key = this.editingApiKey.key
      }
      this.closeApiKeyDialog()
    },
    toggleApiKeyVisibility(fkModel) {
      this.$set(this.showApiKeyInTable, fkModel, !this.showApiKeyInTable[fkModel])
    },
    removeExchange(val) {
      this.modExchangeRates = this.modExchangeRates.filter(v => v !== val)
    },
    updateExchange(oldVal, newVal) {
      oldVal.startDate = newVal.startDate
      oldVal.usdToZar = +newVal.usdToZar
    },
    removePrice(val) {
      this.modModelPricing = this.modModelPricing.filter(v => v !== val)
    },
    updatePrice(oldVal, newVal) {
      oldVal.startDate = newVal.startDate
      oldVal.mTokenOutput = +newVal.mTokenOutput
      oldVal.mTokenInput = +newVal.mTokenInput
      oldVal.costMultiplier = +newVal.costMultiplier
    },
    newModel() {
      this.selectedModel = {
        id: null,
        ecosystem: null,
        modelId: null,
        name: null,
        isToolsEnabled: false,
        isActive: true,
      }
      this.$refs.modelInfoForm?.reset()
    },
    
    async startup() {
      try {
        this.loading = true
        const startupData = await this.$newReq('GET', `ai/admin/setup/startup`)
        this.models = startupData.models
        this.pricing = startupData.pricing.map(v => ({
          ...v,
          startDate: v.startDate ? new Date(v.startDate) : null,
        }))
        this.exchangeRates = startupData.exchangeRates.map(v => ({...v, startDate: v.startDate}))
        this.apiKeys = startupData.apiKeys
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loading = false
      }
    },
    
    async upsertModel() {
      try {
        this.savingValues = true
        if (!this.$refs.modelInfoForm.validate())
          return this.$snack.error('Please fix validation errors')
        
        if (!this.modModelPricing.length)
          return this.$snack.error('At least one price needs to be defined')
        
        const {model: savedModel, pricing} = await this.$newReq('POST', `ai/admin/setup/upsert`, {
          model: this.modModel,
          pricing: this.modModelPricing
        })
        
        if (this.modModel.id) {
          this.pricing = this.pricing.filter(v => !!v.fk_model && v.fk_model !== savedModel.id).concat(pricing)
          const upModel = this.models.find(v => v.id === savedModel.id)
          Object.assign(upModel, savedModel)
        } else {
          this.pricing = this.pricing.filter(v => !!v.fk_model && v.fk_model !== savedModel.id).concat(pricing)
          this.models.push(savedModel)
          this.selectedModel = savedModel
        }
        
        this.$snack.info('Changes saved')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.savingValues = false
      }
    },
    
    async upsertExchange() {
      try {
        this.savingValues = true
        
        const {exchangeRates} = await this.$newReq('POST', `ai/admin/setup/exchangeRates`, {exchangeRates: this.modExchangeRates})
        this.exchangeRates = exchangeRates.map(v => ({...v, startDate: v.startDate}))
        
        this.$snack.info('Changes saved')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.savingValues = false
      }
    },
    
    async upsertKeys() {
      try {
        this.savingValues = true
        
        const {apiKeys} = await this.$newReq('POST', `ai/admin/setup/apiKeys`, {apiKeys: this.modApiKeys.filter(v => v.key)})
        this.apiKeys = apiKeys
        
        this.$snack.info('Changes saved')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.savingValues = false
      }
    }
  },
  computed: {
    validationRules() {
      return validationRules
    },
    selectedTab() {
      return this.tabs[this.activeTab]?.id
    },
    filteredModels() {
      return this.models
          .filter(v => !this.modelSearchStr ? true : Object.values(v).join(' ').toLowerCase().includes(this.modelSearchStr?.toLowerCase()))
          .filter(v => this.showDisabledModels ? true : !!v.isActive)
          .sort((a, b) => a.name.localeCompare(b.name))
    },
    sortedPricing() {
      return (this.modModelPricing || []).sort((a, b) => a.startDate - b.startDate)
    },
    sortedExchangeRates() {
      return (this.modExchangeRates || []).sort((a, b) => a.startDate - b.startDate)
    },
    sortedApiKeys() {
      return (this.modApiKeys || []).sort((a, b) => {
        if (a.ecosystem < b.ecosystem) return -1
        if (a.ecosystem > b.ecosystem) return 1
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    sortedExchangeRatesIndex() {
      const obj = {}
      let lastRate = null
      for (const rate of this.sortedExchangeRates) {
        if (!lastRate) obj[rate.startDate] = 'trending_down'
        else obj[rate.startDate] = lastRate > rate.usdToZar ? 'trending_down' : 'trending_up'
        lastRate = rate.usdToZar
      }
      return obj
    },
  },
}
</script>


<style scoped>

</style>